'use strict';
const svgMarkupBuilder = require('./markup-builder').svgMarkupBuilder,
	buildBackgroundRect = function (dimensions, nodeTheme) {
		return svgMarkupBuilder('rect').attr(Object.assign({
			fill: nodeTheme.decorations.backgroundColor,
			'rx': nodeTheme.decorations.cornerRadius,
			'ry': nodeTheme.decorations.cornerRadius
		}, dimensions, {x: 0, y: 0}));
	},
	buildLabelBorderRect = function (dimensions, nodeTheme) {
		return svgMarkupBuilder('rect').attr({
			x: 0,
			y: 0,
			width: dimensions.labelWidth,
			height: Math.round(dimensions.height - 2 * nodeTheme.decorations.margin),
			fill: 'transparent',
			stroke: nodeTheme.decorations.color,
			'rx': nodeTheme.decorations.label.cornerRadius,
			'ry': nodeTheme.decorations.label.cornerRadius,
			'stroke-width': nodeTheme.decorations.label.border
		});
	},
	writeLabel = function (textEngine, nodeView) {
		const margin = nodeView.theme.decorations.margin,
			labelLeft = nodeView.metrics.decorations.width - nodeView.metrics.decorations.labelWidth - margin,
			labelGroup = svgMarkupBuilder('g').attr('transform', 'translate(' + labelLeft + ',' + margin + ')'),
			labelTextInset = nodeView.theme.decorations.label.margin + nodeView.theme.decorations.label.border,
			labelTextPosition = svgMarkupBuilder('g').attr('transform', 'translate(' + labelTextInset + ',' + labelTextInset + ')'),
			fontMetrics = {
				fontSize: nodeView.theme.decorations.label.font.sizePx,
				lineSpacing: nodeView.theme.decorations.label.font.lineSpacingPx,
				weight: nodeView.theme.decorations.label.font.weight,
				family: 'Sans'
			};

		buildLabelBorderRect(nodeView.metrics.decorations, nodeView.theme).appendTo(labelGroup);
		labelTextPosition.appendTo(labelGroup);
		textEngine.writeLine(nodeView.label, fontMetrics, nodeView.theme.decorations.color).appendTo(labelTextPosition);

		return labelGroup;
	},
	writeStickers = function (stickersEngine, nodeView) {
		const margin = nodeView.theme.decorations.margin,
			size = nodeView.theme.decorations.height,
			stickersGroup = svgMarkupBuilder('g').attr('transform', 'translate(' +  margin + ',' + margin + ')');
		stickersEngine.writeStickers(nodeView.stickers, size, nodeView.metrics.decorations.standardDecorationsWidth).appendTo(stickersGroup);
		return stickersGroup;
	};
module.exports = function writeNodeDecorations(textEngine, stickersEngine, nodeView, nodeElement) {
	const hasLabel = !!nodeView.label,
		hasStickers = !!nodeView.stickers.length,
		left = nodeView.metrics.decorations && nodeView.metrics.decorations.x,
		top = nodeView.metrics.decorations && nodeView.metrics.decorations.y,
		g = svgMarkupBuilder('g').attr('transform', 'translate(' + left + ',' + top + ')');

	if (!hasLabel && !hasStickers) {
		return;
	}
	buildBackgroundRect(nodeView.metrics.decorations, nodeView.theme).appendTo(g);
	if (hasLabel) {
		writeLabel(textEngine, nodeView).appendTo(g);
	}
	if (hasStickers) {
		writeStickers(stickersEngine, nodeView).appendTo(g);
	}
	g.appendTo(nodeElement);
};
